import * as React from 'react';
import {FunctionComponent} from 'react';
import {classNames} from '../support/classnames';
import {format, isSameWeek, getWeek} from 'date-fns';
import {Holiday} from '../../models/holiday';

interface OwnProps {
    now: Date;
    date: Date;
    compact: boolean;
    holidays: Holiday[];
}

export const ColumnHeader: FunctionComponent<OwnProps> = ({now, date, holidays, compact}) => {
    const formattedDate = format(date, compact ? 'MM dd' : 'yyyy-MM-dd');
    const holidaysThisWeek = holidays.filter((holiday) => isSameWeek(date, holiday.date));

    const week = getWeek(date, {
        weekStartsOn: 1,
        firstWeekContainsDate: 4,
    });

    if (holidaysThisWeek.length === 0 || compact) {
        return (
            <th className={classNames({active: isSameWeek(now, date)})}>
                {formattedDate} <span className="text-muted">(w{week})</span>
            </th>
        );
    }

    return (
        <th
            className={classNames(
                {
                    active: isSameWeek(now, date),
                },
                'has-tooltip ion-alert-circled',
            )}>
            <div className="tooltip">
                {holidaysThisWeek.map((holidayThisWeek) => {
                    return (
                        <div key={holidayThisWeek.name} className="holiday">
                            {holidayThisWeek.name}
                        </div>
                    );
                })}
            </div>
            {formattedDate} <span className="text-muted">(w{week})</span>
        </th>
    );
};
